import React from 'react'
import { Header, TokenNavLink } from 'catena/er2_ui'
import ErrorBoundary from 'catena/er2_map_userlayers/js/components/error_boundary'
import * as routes from '../constants/routes'
import { getFicusPathFromNode } from '../util/ficus'

const renderHeader = (props, logout) => (
    <Header token={props.token} meta={props.meta} theme={props.classes}>
        <div>
            <div className={props.classes.logoCtr}>
                <TokenNavLink
                    className={props.classes.headerLink}
                    token={props.token}
                    role="button"
                    to={routes.HOME}
                >
                    <span className={props.classes.logo}>FICUS</span>
                    <span className={props.classes.logoVersion}>v. {props.meta.version}</span>
                </TokenNavLink>
            </div>
            <ErrorBoundary>
                <div
                    style={{
                        cursor: 'pointer',
                        position: 'absolute',
                        right: 40,
                        top: 14,
                    }}
                >
                    <span>{props.meta.user ? props.meta.user.id : '<anon>'}</span>
                </div><div
                    onClick={logout}
                    role="button"
                    tabIndex="-1"
                    style={{
                        cursor: 'pointer',
                        position: 'absolute',
                        right: 10,
                        top: 14,
                    }}
                >
                    <span className="fa fa-sign-out" title="Logout" style={{ color: 'white', fontSize: '22px' }} />
                </div>
            </ErrorBoundary>
            <div
                className={props.classes.nodeHeader}
            >
                {getFicusPathFromNode(props.selectFrameworkBar.ficusNode)}
            </div>
        </div>
    </Header>
)

export { renderHeader }
